import axios from 'axios'

const apiUrl = process.env.VUE_APP_PUBLIC_DAY_API_URL

export const getPublicHoliday = (): Promise<string[]> =>
  axios.get(apiUrl!).then(response => {
    const publicDay = response.data.items.map((item :any) => item.start.date)
    return publicDay
  })
